"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SWITCH_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var SWITCH_SIZES = Object.freeze({
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.SWITCH_SIZES = SWITCH_SIZES;